"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ticketTypes = exports.connectionTypeName = exports.classes = void 0;
var classes = {
  container: 'advanced-settings-header-class',
  headerClass: 'header-class',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8',
  pillContainer: 'ITSM-pill-container'
};
exports.classes = classes;
var connectionTypeName = {
  servicenow: 'ServiceNow',
  jira: 'Jira'
};
exports.connectionTypeName = connectionTypeName;
var ticketTypes = {
  issue: 'Issue',
  incident: 'Incident',
  change_request: 'Change Request'
};
exports.ticketTypes = ticketTypes;